module.exports = __webpack_public_path__ + "img/zm.a9ff495d.svg";